import SweetAlert from './mixins'
import Swal from 'sweetalert2'
import { HTTP } from './axiosConfig'

const duplicateAction = {
    mixins: [SweetAlert],
    methods: {
        triggerDuplicateAction (id) {
            let my = this
            Swal({
                title: my.labels['duplicate_product_warning'],
                showCancelButton: true,
                confirmButtonText: my.labels['proceed']
            })
                .then((response) => {
                    if (response.value) {
                        this.duplicateProduct(id)
                    }
                })
        },
        duplicateProduct (id) {
            var sonId = this.uuid()
            HTTP.post(`/api/products/${id}/sons`, {
                son_id: sonId
            })
                .then(() => {
                    // Go to edit product step1
                    this.sweetAlert('success', this.labels.product_duplicated, 2000)
                    this.$router.push({name: 'ProductFormExt', query: { productId: sonId }})
                })
                .catch((err) => this.sweetAlert('error', this.labels.error_duplicating_product, 2000))
        }
    }
}

export default duplicateAction



// WEBPACK FOOTER //
// ./src/assets/js/duplicateMixin.js